import { OptionDefinition, OptionGroupDefinition, ProductDefinition } from './yaml-models.js';

export interface YamlTransformer {
  preProcessOption(option: OptionDefinition): void;

  preProcessProduct(product: ProductDefinition): void;

  preProcessOptionGroups(optionGroup: OptionGroupDefinition): void;

  postProcessProduct(product: ProductDefinition): void;
}

export class NullYamlTransformer implements YamlTransformer {
  preProcessOption(option: OptionDefinition): void {
  }

  preProcessProduct(product: ProductDefinition): void {
  }

  preProcessOptionGroups(optionGroup: OptionGroupDefinition): void {
  }

  postProcessProduct(product: ProductDefinition): void {
  }
}
